/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import impersonateImage from '../../assets/impersonateImage.png';
import { LoadingSpinner } from '../../components/loadingSpinner/loadingspinner';
import {
    ADMINIMPERSONATE,
    ADMIN_SECURITY_GROUP,
    AGENTROLE,
    CATEMPLATES,
    COMPENSATION,
    COMPENSATION_SECURITY_GROUP,
    // CORRECTIVEACTIONS,
    EDSDASHBOARD,
    EDS_SECURITY_GROUP,
    HC_SECURITY_GROUP,
    // HOMEPAGE,
    LANDINGPAGE,
    MANAGERDASHBOARD,
    MANAGERROLE,
    MYMETRICS,
    ROLES,
    SCORECARDDASHBOARD,
    SUPERVISORROLE,
    UNAUTHORIZED,
} from '../../constants';
import { selectCurrentEmpid, selectCurrentRole, 
    //selectIsManagerRecentApprover,
    setCredentials } from '../login/authSlice';
import './impersonate.scss';
import { useGetImpersonatorDetailQuery } from './impersonateSlice';
import { removeSelectedLocalStorageKeys } from '../../utils/clearLocalStorageKeys';
import { useGetManagerRecentApprovalsCountQuery } from '../managerDashboard/managerDashboardSlice';

interface ImpersonateProps {
    flag: boolean;
    userName?: string;
    userOracleId?: number;
}

export const Impersonate = ({ flag, userName, userOracleId }: ImpersonateProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedRole = useSelector(selectCurrentRole);
    // const isAdmin = useSelector(selectCurrentIsAdmin);
    const [visible, setVisible] = useState<boolean>(false);
    const [impersonateUserOracleId, setImpersonateUserOracleId] = useState('');
    const [oracleId, setOracleId] = useState<any>('');
    const [heading, setHeading] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [localLoading, setLocalLoading] = useState(false);
    const [shouldFetchManagerApi, setShouldFetchManagerApi] = useState(false);
   
    const { data: impersonateData, isFetching: userDataIsFetching } = useGetImpersonatorDetailQuery(
        {
            impersonatorOracleId: oracleId,
            impersonatedOracleId: loggedEmpNum,
        },
        { skip: oracleId.length < 7 || !loggedEmpNum }
    );
     const { data: employeeRecentApproverStatus, isFetching : isRecentApproverFetching } = useGetManagerRecentApprovalsCountQuery(
            { employeeNumber: oracleId },
            {
                skip: !oracleId || !shouldFetchManagerApi
            }
        );
    const sleep = (ms: number) =>
        new Promise<void>((resolve) => {
            setTimeout(resolve, ms);
        });
    const handleClick = async () => {
        const impersonateOracleID = impersonateUserOracleId.trim();
        if (flag) {
            setOracleId(userOracleId);
        }
        if (flag === false) {
            setLocalLoading(true);
            await sleep(500);
            if (window.localStorage.getItem('isUserImpersonate') === 'true') {
                if (loggedEmpNum === impersonateOracleID) {
                    setVisible(false);
                    if (impersonateData?.data != null && impersonateData?.data?.result_count > 0) onHide();
                    else setOracleId(impersonateOracleID);
                } else if (oracleId !== impersonateOracleID) setOracleId(impersonateOracleID);
            } else if (loggedEmpNum === impersonateOracleID) {
                toast.error('Self Impersonation is not allowed');
            } else if (impersonateOracleID.length < 7 && typeof impersonateOracleID !== 'number') {
                setError(`Please enter valid oracleId ${impersonateOracleID}`);
            } else {
                if(window.localStorage.getItem('SCfilDate')){
                    removeSelectedLocalStorageKeys(['SCfilDate']);
                }
                setOracleId(impersonateOracleID);
            }
            setLocalLoading(false);
        }
    };

    const onHide = () => {
        setVisible(false);
        if (loggedRole === AGENTROLE) {
            navigate(MYMETRICS);
        } else if (loggedRole === SUPERVISORROLE) {
            navigate(SCORECARDDASHBOARD);
        }
    };
    useEffect(() => {
        if (!shouldFetchManagerApi) return;
        if (isRecentApproverFetching) return;
        if (!employeeRecentApproverStatus?.status) return;

        const isRecentApprover = employeeRecentApproverStatus.data === true;

        const route = isRecentApprover ? LANDINGPAGE : MANAGERDASHBOARD;

        navigate(route, { replace: true });

    }, [
        shouldFetchManagerApi,
        isRecentApproverFetching,
        employeeRecentApproverStatus,
        navigate
    ]);
    useEffect(() => {
        if (flag) {
            setHeading('Delegation');
            setVisible(true);
            //setOracleId(userOracleId);
        } else {
            setHeading('Impersonate');
            setVisible(true);
        }
    }, [flag]);
    
    useEffect(() => {
        if (impersonateData?.data != null && impersonateData?.data?.result_count > 0) {
            if (
                impersonateData?.data?.isUserActive !== null &&
                impersonateData?.data?.isUserActive === false
            ) {
                setError(
                    `User is not active in AD for : ${impersonateUserOracleId} - ${impersonateData?.data?.result[0]?.givenName}`
                );
                setTimeout(() => {
                    navigate(UNAUTHORIZED, { replace: true });
                }, 5000);
                return;
            }

            if (impersonateData.data.result[0].error && impersonateData.data.result[0].error !== '') {
                toast.warn(
                    'LDAP services are temporarily unavailable. Functionality for impersonated users with elevated roles may be limited during this time.'
                );
            }

            const userManagerLevel = impersonateData.data.result[0].userManagerLevel;
            if (flag) {
                setVisible(false);
            }
            if (userManagerLevel === '') {
                navigate(UNAUTHORIZED, { replace: true });
                return;
            }

            let role = '';
            const empid = oracleId;
            let user = '';
            if (ROLES.Agents?.find((role) => impersonateData.data.result[0].userManagerLevel?.includes(role)))
                role = AGENTROLE;
            if (
                ROLES.Supervisor?.find((role) =>
                    impersonateData.data.result[0].userManagerLevel?.includes(role)
                )
            )
                role = SUPERVISORROLE;
            if (
                ROLES.Manager?.find((role) => impersonateData.data.result[0].userManagerLevel?.includes(role))
            ){
                role = MANAGERROLE;                
                setShouldFetchManagerApi(true);
            }

            //  user = ` ${impersonateData?.data.result[0].givenName} (Impersonating)`;

            if (flag) {
                user = `${impersonateData?.data.result[0].givenName} (Delegate Mode)`;
            } else {
                user = ` ${impersonateData?.data.result[0].givenName} (Impersonating)`;
            }
            const userFullName = ` ${impersonateData?.data.result[0].givenName} (Impersonating)`;
            const userNameWithId = `${impersonateData?.data.result[0].sn}, ${impersonateData?.data.result[0].givenName} (${impersonateData?.data.result[0].employeeID})`;

            if (ROLES.Agents?.find((role) => impersonateData.data.result[0].userManagerLevel?.includes(role)))
                role = AGENTROLE;
            if (
                ROLES.Supervisor?.find((role) =>
                    impersonateData.data.result[0].userManagerLevel?.includes(role)
                )
            )
                role = SUPERVISORROLE;
            if (
                ROLES.Manager?.find((role) => impersonateData.data.result[0].userManagerLevel?.includes(role))
            )
                role = MANAGERROLE;            

            const isEDSGroup = impersonateData.data.result[0].memberOf?.includes(EDS_SECURITY_GROUP);
            const isAdminGroup = impersonateData.data.result[0].memberOf?.includes(ADMIN_SECURITY_GROUP);
            const isCompGroup =
                impersonateData.data.result[0].memberOf?.includes(COMPENSATION_SECURITY_GROUP);
            const isHCGroup = impersonateData.data.result[0].memberOf?.includes(HC_SECURITY_GROUP);

            if (role === '') {
                // if(isEDSGroup === false && isAdminGroup === false && isCompGroup === false){
                navigate(UNAUTHORIZED, { replace: true });
                return;
                // }
            }

            // if (ROLES.Manager?.find(role => userManagerLevel?.includes(role))){
            //     isEDSGroup= true;
            // } //E20-1149-Managers-need-to-access-EDS-Data-workflow, Needs to changed
            const userobj = {
                empid,
                user,
                email: impersonateData?.data.result[0].mail,
                role,
                userManagerLevel,
                isAdmin: isAdminGroup,
                isEds: isEDSGroup,
                isComp: isCompGroup,
                isDelegate: flag,
                userFullName,
                isHC: isHCGroup,
                userNameWithId,
            };

            dispatch(setCredentials(userobj));

            window.localStorage.isUserImpersonate = 'true';
            setVisible(false);

            let route;
        if ((role === AGENTROLE || role === SUPERVISORROLE) && !isEDSGroup && !isCompGroup) {
            route = LANDINGPAGE;
        } else if (role === MANAGERROLE) {
            route = MANAGERDASHBOARD;
            return;
        } else if (!isAdminGroup) {
            if (isEDSGroup && !flag) {
                route = EDSDASHBOARD;
            } else if (isCompGroup) {
                route = COMPENSATION;
                } else if (isHCGroup) {
                    route = CATEMPLATES;
                } else {
                    route = UNAUTHORIZED;
                }
            } else {
                route = UNAUTHORIZED;
            }

            navigate(route, route === UNAUTHORIZED ? { replace: true } : undefined);

        } else if (impersonateData?.data.result_count === 0) {
            setError(`No User found in AD for oracleId : ${impersonateUserOracleId}`);

            setTimeout(() => {
                navigate(UNAUTHORIZED, { replace: true });
            }, 3000);
        } else {
            if (impersonateUserOracleId.trim().toString().length > 0)
                setError(`Something Wrong with : ${impersonateUserOracleId}`);
            if (!flag) {
                setTimeout(() => {
                    navigate(ADMINIMPERSONATE);
                }, 3000);
            }
        }
    }, [impersonateData]);

    return (
        <div>
            <Dialog
                visible={visible}
                style={{ width: '33vw', maxWidth: '50vw', padding: '0px' }}
                onHide={onHide}
                draggable={false}
                className="impersonateWindow"
            >
                <div className="card border-0 rounded">
                    <div className="card-body p-0">
                        <div className="row" style={{ padding: '1px', margin: '2px' }}>
                            <div
                                className="col-md-6 p-5 pt-4 px-4 text-center"
                                style={{ backgroundColor: '#E0F0FF' }}
                            >
                                <h6 className="pb-3" style={{ fontSize: '24px', fontWeight: '700' }}>
                                    {heading}
                                </h6>
                                <img src={impersonateImage} alt="Impersonate" className="img-fluid" />
                            </div>
                            <div className="col-md-6 p-4 pt-5">
                                {flag ? (
                                    <div>
                                        <h5 className="pt-4">User&apos;s Name </h5>
                                        <InputText
                                            value={userName}
                                            placeholder="Enter Oracle"
                                            disabled
                                            type="string"
                                            className="form-control rounded"
                                        />
                                        <h5 className="pt-4">User&apos;s Oracle Id</h5>
                                        <InputText
                                            value={userOracleId}
                                            placeholder="Enter Oracle Id"
                                            disabled
                                            type="number"
                                            className="form-control rounded"
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        <h5 className="pt-4">User&apos;s Oracle Id</h5>
                                        <InputText
                                            value={impersonateUserOracleId}
                                            placeholder="Enter Oracle Id"
                                            onChange={(e) => setImpersonateUserOracleId(e.target.value)}
                                            type="number"
                                            className="form-control rounded"
                                        />
                                    </div>
                                )}

                                <Button
                                    label="Submit"
                                    data-testid="btnSubmit"
                                    aria-label="Submit"
                                    onClick={handleClick}
                                    className="btn-primary mt-4 w-100"
                                />
                                <span>{userDataIsFetching || localLoading ? <LoadingSpinner /> : ''}</span>
                            </div>
                            <div>
                                <span className="error-text" id="errMessage">
                                    {error}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
